var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification-list',{key:_vm.isVisible,attrs:{"is-loading":_vm.isLoading,"notifications":_vm.notifications,"pagination":_vm.pagination},on:{"pagination":_vm.onPagination}})
}
var staticRenderFns = []

export { render, staticRenderFns }